'use client';

import { useRef, useState, useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import './CarModelDetails.scss';
import CarModelDesktop from './Desktop/CarModelDesktop';
import CarModelMobile from './Mobile/CarModelMobile';

export default function CarModelDetails({ fields }) {
  const [tab, setTab] = useState(fields);
  const swiperRef = useRef(null);
  const swiperRefMobile = useRef(null);

  // 使用 useMediaQuery 检测屏幕尺寸
  const isMobile = useMediaQuery('(max-width: 980px)');

  // 监听 fields 变化，同步更新 tab 状态
  useEffect(() => {
    if (fields) {
      setTab(fields);
    }
  }, [fields]);

  const marks = fields?.marks;
  const updateMarks = (index) => {
    setTab((prevTab) => ({
      ...prevTab,
      marks: prevTab.marks.map((mark) => ({
        ...mark,
        open: mark.fields?.id?.value === index,
      })),
    }));
  };

  const handleClickMark = (index) => {
    // 先更新 marks 状态，这会触发 Carousel 组件的渲染
    updateMarks(index);

    // 延迟调用 slideTo，确保 Swiper 已经初始化
    setTimeout(() => {
      if (isMobile) {
        swiperRefMobile.current?.slideTo(index - 1);
      } else {
        swiperRef.current?.slideTo(index - 1);
      }
    }, 50); // 减少延迟时间，50ms 通常足够
  };

  const handleClose = () => {
    updateMarks(null);
  };

  const setSlideIndex = (index) => {
    // 根据当前屏幕尺寸调用对应的 swiper
    if (isMobile) {
      swiperRefMobile.current?.slideTo(index);
    } else {
      swiperRef.current?.slideTo(index);
    }
    updateMarks(index + 1);
  };

  return (
    <div className={'container car-model-details'}>
      <div className={'wrapper'} id="Overview">
        {/* 只在有 title 时显示标题 */}
        {fields?.title?.value && (
          <h2 className={'title'} data-aos="fade-up">
            {fields.title.value}
          </h2>
        )}

        {/* 根据屏幕尺寸条件渲染，确保只有一个版本被渲染 */}
        {!isMobile && (
          <CarModelDesktop
            tab={tab}
            swiperRef={swiperRef}
            onClickMark={handleClickMark}
            onClose={handleClose}
            setSlideIndex={setSlideIndex}
          />
        )}

        {isMobile && (
          <CarModelMobile
            tab={tab}
            swiperRef={swiperRefMobile}
            onClickMark={handleClickMark}
            onClose={handleClose}
            setSlideIndex={setSlideIndex}
          />
        )}
      </div>
    </div>
  );
}
